import { useEffect, useState } from "react";

export default function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(true);
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    function updateOnline() {
      setIsOnline(navigator.onLine);
    }

    window.addEventListener("online", updateOnline);
    window.addEventListener("offline", updateOnline);

    // Slow internet detection (optional)
    let lastTime = Date.now();
    const checkSpeed = () => {
      const img = new Image();
      img.src =
        "https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png?" +
        lastTime;
      const start = Date.now();
      img.onload = () => {
        const duration = Date.now() - start;
        setIsSlow(duration > 1500); // >1.5 sec = slow network
      };
      img.onerror = () => setIsSlow(true);
    };

    const interval = setInterval(checkSpeed, 5000);
    checkSpeed();

    return () => {
      window.removeEventListener("online", updateOnline);
      window.removeEventListener("offline", updateOnline);
      clearInterval(interval);
    };
  }, []);

  return { isOnline, isSlow };
}
